import { render, staticRenderFns } from "./AIdTokenOptions.vue?vue&type=template&id=48e96598&"
import script from "./AIdTokenOptions.vue?vue&type=script&lang=js&"
export * from "./AIdTokenOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports